import React from 'react';

import { awards } from '../../content/siteContent.mjs';
import SmartImage from './SmartImage';

/** The two Best of Westchester badges — the strongest trust signal we have. */
export const AwardBadges = ({ compact = false }) => (
  <div className={`flex items-center ${compact ? 'gap-4' : 'gap-6'}`} data-testid="award-badges">
    {awards.map((award) => (
      <div key={award.year} className="flex items-center gap-3">
        <SmartImage
          image={award.image}
          priority={compact}
          className={compact ? 'h-14 w-14 object-contain' : 'h-20 w-20 object-contain'}
        />
        {!compact && (
          <div className="text-left">
            <p className="text-sm font-bold text-gray-900">{award.title}</p>
            <p className="text-xs text-gray-500">
              {award.source} · {award.year}
            </p>
          </div>
        )}
      </div>
    ))}
    {compact && (
      <p className="text-sm font-medium text-gray-600">
        Best of Westchester — Best Donuts, 2020 &amp; 2023
      </p>
    )}
  </div>
);

export default AwardBadges;
